import { AxiosRequestConfig } from 'axios';
import { HttpResponse, ajax } from '../../../../common/ajax';
import { config } from '../../config';
import { CountyFilterModel } from '../../models/filters';

interface IFiltersService {
  getCountiesWithCities: (
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<CountyFilterModel[]>>;
}

export const filtersService: IFiltersService = {
  getCountiesWithCities(axiosConfig) {
    return ajax.get<CountyFilterModel[]>(
      `${config.merchantsApiUrl}/filters/counties`,
      axiosConfig,
    );
  },
};
